import React from "react";

type GroupWidgetFooterProps = {
  totalAssets: number;
  totalModels: number;
};

const GroupWidgetFooter = ({ totalAssets, totalModels }: GroupWidgetFooterProps) => {
  return (
    <div className="flex flex-wrap items-center justify-between sm:justify-end gap-3 sm:gap-8 border border-eai-bg-lt2 bg-white px-3 sm:px-4 py-3 rounded-b-[8px]">
      <div className="text-[13px] sm:text-[14px] text-[#4B5563]">
        Total Assets: <span className="font-semibold text-[#111928]">{totalAssets}</span>
      </div>
      <div className="text-[13px] sm:text-[14px] text-[#4B5563]">
        Total Models: <span className="font-semibold text-[#111928]">{totalModels}</span>
      </div>
    </div>
  );
};

export default GroupWidgetFooter;
